﻿import config from "../config"
const baseUrl = config.base_url + "ali/"
export default {
    credential: {
        url:  baseUrl + "credential",
        type: "post",
    },
    configCodeList: {
        url: baseUrl + "config_code_list",
        type: "get",
    },
    credentialByConfig: {
        url: baseUrl + "credential_by_config",
        type: "get",
    },
}

